import { useState } from 'react';

const faqs = [
  {
    q: '가족이 간병해도 보험금 지급이 가능한가요?',
    a: '가능합니다. 대부분의 간병보험은 가족이 직접 간병해도 조건만 충족하면 보험금 지급이 가능합니다. 보험사별로 필요 서류와 인정 기준이 조금씩 다르니 코리아케어러스에 문의하시면 정확히 안내해 드립니다.',
  },
  {
    q: '간병비 소급 적용이 가능한가요?',
    a: '불가능합니다. 간병인은 등록된 일자부터 자격이 인정되며, 등록 이전의 간병 이력은 보험사에서 인정되지 않아 소급 적용이 불가합니다. 소급적용이 된다고 하는 업체가 있다면 주의하셔야 합니다. 코리아케어러스는 정도영업을 준수합니다.',
  },
  {
    q: '간병인 자격증 없이 가족 간병이 가능한가요?',
    a: '물론입니다. 가족간병인은 별도의 국가자격증이나 교육 과정이 필요하지 않습니다. 코리아케어러스에 공식적으로 등록만 해도 보험사에서 인정하는 간병인으로 활동하실 수 있습니다.',
  },
  {
    q: '가족간병은 전국 어디서든 이용할 수 있나요?',
    a: '네, 코리아케어러스는 전국을 대상으로 가족간병 등록과 간병보험 청구 서류 발급을 지원합니다. 본사는 전주에 있지만 거주 지역과 상관없이 전화·온라인으로 등록과 상담이 가능하며, 필요 서류도 발급 후 받아보실 수 있습니다.',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row gap-12 items-start">
          {/* Left sticky title */}
          <div className="md:w-72 flex-shrink-0 md:sticky md:top-24">
            <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: '#2E7D6B' }}>FAQ</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">자주 묻는<br />질문</h2>
            <p className="text-sm text-gray-500 leading-relaxed mb-6">
              간병보험 청구에 대해 궁금한 점이 있으시면 언제든지 문의해 주세요.
            </p>
            <a
              href="tel:15668654"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold text-white cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-phone-line"></i>1566-8654 문의
            </a>
          </div>

          {/* Right: accordion */}
          <div className="flex-1 flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="rounded-2xl overflow-hidden border transition-all"
                style={{ borderColor: openIdx === i ? '#2E7D6B' : '#f0f0f0' }}
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
                  onClick={() => setOpenIdx(openIdx === i ? null : i)}
                >
                  <span className="text-sm font-semibold text-gray-900 flex items-center gap-3">
                    <span
                      className="w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold text-white flex-shrink-0"
                      style={{ backgroundColor: openIdx === i ? '#2E7D6B' : '#e8f5f1', color: openIdx === i ? '#fff' : '#2E7D6B' }}
                    >
                      Q
                    </span>
                    {faq.q}
                  </span>
                  <i
                    className={`ri-${openIdx === i ? 'subtract' : 'add'}-line flex-shrink-0 ml-3 transition-colors`}
                    style={{ color: openIdx === i ? '#2E7D6B' : '#9ca3af' }}
                  ></i>
                </button>
                {openIdx === i && (
                  <div className="px-6 pb-5 flex gap-3">
                    <span
                      className="w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold flex-shrink-0 mt-0.5"
                      style={{ backgroundColor: '#e8f5f1', color: '#2E7D6B' }}
                    >
                      A
                    </span>
                    <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
